export default __webpack_public_path__ + "06639684e937ff340cc9df8c6d3ebc4c.png";